import React, { useMemo } from "react";
import "./Terms.css";
import { useLocalContext } from "../../context/LocalContext";

const Terms = () => {
  const { webinfo = {} } = useLocalContext();

  const brand = useMemo(
    () => ({
      name: webinfo.name || "Your Brand",
      email: webinfo.email || "hello@example.com",
      phone: webinfo.phone || "+91 80000 00000",
      phonecall: webinfo.phonecall || "+918000000000",
      address: webinfo.address || "Remote-first • Serving clients worldwide",
    }),
    [webinfo]
  );

  const effectiveDate = useMemo(
    () =>
      new Date().toLocaleDateString(undefined, {
        year: "numeric",
        month: "long",
        day: "numeric",
      }),
    []
  );

  return (
    <section className="terms">
      <div className="terms-wrap">
        {/* Header */}
        <header className="terms-head">
          <span className="terms-kicker">Legal</span>
          <h1>Terms &amp; Conditions</h1>
          <p className="terms-meta">
            <span>Provider: {brand.name}</span>
            <span>Last updated: {effectiveDate}</span>
          </p>
        </header>

        {/* Content */}
        <div className="terms-content">
          <TermsBlock title="1. Scope of these Terms">
            <p>
              These Terms govern your use of our website and any services
              provided by {brand.name}. Project-specific agreements, proposals,
              or contracts will take precedence where applicable.
            </p>
          </TermsBlock>

          <TermsBlock title="2. Website use & content">
            <p>
              You agree to use our website lawfully and respectfully. All
              content, design, and code are owned or licensed by {brand.name}
              and may not be reused without written permission.
            </p>
          </TermsBlock>

          <TermsBlock title="3. Proposals & scope">
            <p>
              Only work explicitly agreed in writing is considered in scope.
              Additional requests may require revised timelines or fees.
            </p>
          </TermsBlock>

          <TermsBlock title="4. Client responsibilities">
            <ul>
              <li>Provide accurate content and timely feedback</li>
              <li>Ensure supplied materials do not violate third-party rights</li>
              <li>Maintain access to required tools and accounts</li>
            </ul>
          </TermsBlock>

          <TermsBlock title="5. Fees & payments">
            <p>
              Payment terms are defined in your agreement. Work may pause if
              invoices become overdue. Completed work and deposits are
              generally non-refundable.
            </p>
          </TermsBlock>

          <TermsBlock title="6. Intellectual property">
            <p>
              Upon full payment, you receive usage rights for the final
              deliverables. Our internal processes and frameworks remain our
              intellectual property.
            </p>
          </TermsBlock>

          <TermsBlock title="7. Third-party services">
            <p>
              External platforms operate under their own policies. We are not
              responsible for outages, pricing changes, or limitations imposed
              by third-party providers.
            </p>
          </TermsBlock>

          <TermsBlock title="8. Confidentiality">
            <p>
              Both parties agree to keep non-public information confidential,
              including credentials, data, and internal documentation.
            </p>
          </TermsBlock>

          <TermsBlock title="9. Use of AI tools">
            <p>
              We may use AI or automation tools to support delivery. Final
              responsibility and approval remain with you.
            </p>
          </TermsBlock>

          <TermsBlock title="10. Limitation of liability">
            <p>
              To the extent permitted by law, our liability is limited to the
              fees paid in the three months prior to any claim.
            </p>
          </TermsBlock>

          <TermsBlock title="11. Changes to these Terms">
            <p>
              We may update these Terms from time to time. Continued use of our
              services implies acceptance of the revised Terms.
            </p>
          </TermsBlock>

          <TermsBlock title="12. Contact">
            <ul className="terms-contact">
              <li>
                <strong>Email:</strong>{" "}
                <a href={`mailto:${brand.email}`}>{brand.email}</a>
              </li>
              <li>
                <strong>Phone:</strong>{" "}
                <a href={`tel:${brand.phonecall}`}>{brand.phone}</a>
              </li>
              <li>
                <strong>Address:</strong> {brand.address}
              </li>
            </ul>
          </TermsBlock>
        </div>
      </div>
    </section>
  );
};

/* Reusable block */
const TermsBlock = ({ title, children }) => (
  <section className="terms-card">
    <h2>{title}</h2>
    {children}
  </section>
);

export default Terms;
